import { config } from '@abyss/web/tools/config';
import { useState } from 'react';

import { ProviderType } from '../../models/ProviderDetails';
import { useCustomQuery } from '../useCustomQuery';
import GET_FACILITY_DETAILS from '../useProviderDetails/FacilityDetails.graphql';
import GET_PROVIDER_DETAILS from '../useProviderDetails/ProviderDetails.graphql';

export const useProviderDetailsSearch = (
  options,
  providerType = ProviderType.PRACTITIONER
) => {
  const query =
    providerType.toUpperCase() === ProviderType.PRACTITIONER.toUpperCase()
      ? GET_PROVIDER_DETAILS
      : GET_FACILITY_DETAILS;

  const accessor =
    providerType.toUpperCase() === ProviderType.PRACTITIONER.toUpperCase()
      ? 'providerDetails'
      : 'facilityDetails';

  const [providerDetails, setProviderDetails] = useState({});
  const [queryResult, queryAction] = useCustomQuery(query, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor,
    onCompleted: (result) => {
      if (options?.onCompleted) {
        options.onCompleted(result?.data);
      }
      setProviderDetails(result?.data);
    },
  });

  const parsedResult = {
    ...queryResult,
    data: providerDetails,
  };

  return [parsedResult, queryAction];
};
